module.exports = __webpack_public_path__ + "img/infoSheet.764cf960.png";